<template>
  <div class='h100'>
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <div>
          <div v-if='true'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-edit" @click='buttonClk()' :title='$t("TS.configTime")'/></div>
        </div>
      </ejs-toolbar>
    </div>
    <div align='center'>
      <ejs-chart ref='singleChart' align='center' style='display:block' :height='height' :width='width' :primaryXAxis='primaryXAxis'
                 :primaryYAxis='primaryYAxis' :chartArea='chartArea' :tooltip='tooltip' :legendSettings='legend' :zoomSettings='zoomSettings' selectionMode='DragX' >
        <e-series-collection>
          <e-series :dataSource='singledata' type='Column' xName='x' yName='y' :name='$t("TS.singleCallSetUpTime")' width=2 :marker='marker' fill='#3BA1FF' > </e-series>
        </e-series-collection>
      </ejs-chart>
    </div>
    <CallDetailGrid ref='callDetailGrid'></CallDetailGrid>
    <CustomDialog ref='setTimePage' :element='dialog.element.eleSetTime' :styles='dialog.styles' :messages='dialog.messages.setTime'>
      <template v-slot:dialog-content>
        <ConfigCallSetUpTimeRangeDialog ref="setTime"></ConfigCallSetUpTimeRangeDialog>
      </template>
    </CustomDialog>
    <!--<div>-->
      <!--<CallDetailGrid ref='callDetailGrid'></CallDetailGrid>-->
    <!--</div>-->
    <!--<div class='h100-300 h-scroll'>-->
        <!--<ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :allowReordering='true' :allowResizing='true'>-->
          <!--<e-columns>-->
            <!--<e-column field='neId' minWidth='10' :headerText='$t("TS.neID")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>-->
            <!--<e-column field='num' minWidth='10' :headerText='$t("TS.userNumber")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>-->
            <!--<e-column field='onlineTime' minWidth='10' :headerText='$t("TS.onlineTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>-->
            <!--&lt;!&ndash;<e-column field='statistic_time' minWidth='10' :headerText='$t("TS.statisticsTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>&ndash;&gt;-->
          <!--</e-columns>-->
        <!--</ejs-grid>-->
        <!--<ejs-pager ref='pager' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>-->
    <!--</div>-->
  </div>
</template>

<script>

import Vue from 'vue';
import { Browser } from '@syncfusion/ej2-base';
import { ChartPlugin, ColumnSeries, Category, DataLabel, Tooltip, Legend, Zoom, ScrollBar, Selection } from '@syncfusion/ej2-vue-charts';
import CustomDialog from '../../common/CustomDialog';
import CallDetailGrid from '../CallCountStatistics/CallDetailGrid';
import ConfigCallSetUpTimeRangeDialog from './ConfigCallSetUpTimeRangeDialog';
import { EventBus } from '../../../plugins/eventBus';
import Global from '../Global';
Vue.use(ChartPlugin);

export default {
  name: 'SingleSetUpTimeDialog',
  components: {
    CustomDialog,
    CallDetailGrid,
    ConfigCallSetUpTimeRangeDialog
  },
  data() {
    return {
      /* seriesData: [
         { x: '00:00~01:00', y: 37 }, { x: '01:00~02:00', y: 23 }, { x: '02:00~03:00', y: 18 },{ x: '03:00~04:00', y: 16 },{ x: '04:00~05:00', y: 16 },{ x: '05:00~06:00', y: 37 }, { x: '06:00~07:00', y: 23 }, { x: '07:00~08:00', y: 18 },{ x: '08:00~09:00', y: 46 }, { x: '09:00~10:00', y: 27 }, { x: '10:00~11:00', y: 26 },{ x: '11:00~12:00', y: 46 }, { x: '12:00~13:00', y: 27 }, { x: '13:00~14:00', y: 56 },{ x: '14:00~15:00', y: 46 }, { x: '15:00~16:00', y: 27 }, { x: '17:00~18:00', y: 56 },{ x: '18:00~19:00', y: 46 }, { x: '19:00~20:00', y: 27 }, { x: '20:00~21:00', y: 56 },{ x: '21:00~22:00', y: 46 }, { x: '22:00~23:00', y: 27 }
       ], */
      searchConditions: {},
      olapUrl: Global.olapUrl,
      primaryXAxis: {
        valueType: 'Category',
        zoomFactor: 1,
        interval: 1,
        majorGridLines: { width: 0 },
        edgeLabelPlacement: 'Shift',
        title: this.$t('TS.ts_call_setup_time')
      },
      primaryYAxis: {
        title: this.$t('TS.ts_count'),
        labelFormat: '{value}'
      },
      width: '800px',
      // width: '60%',
      height: '240px',
      marker: {
        dataLabel: {
          visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' }
        }
      },
      tooltip: {
        enable: true
      },
      legend: {
        visible: true,
        position: 'Top'
      },
      zoomSettings: {
        mode: 'X',
        enableMouseWheelZooming: true,
        enablePinchZooming: true,
        // enableSelectionZooming: true,
        enableScrollbar: true,
        toolbarItems: ['ZoomIn', 'ZoomOut']
      },
      chartArea: {
        border: {
          width: 0
        }
      },
      dialog: {
        styles: {
          width: '40%',
          height: '50%',
          visible: false,
          zIndex: 1101,
          model: true
        },
        element: {
          eleSetTime: {
            target: this.$refs.callSetUpTimeChart,
            refName: 'eleSetTime',
            buttonGroup: [
              { click: this.closeTimePage, buttonModel: { content: this.$t('TS.ts_cancell') } },
              { click: this.saveXAxisTimeFunc, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }

            ],
            title: this.$t('TS.configTime'),
            isClose: true
          }
        },
        messages: {
          setTime: {
            title: this.$t('TS.configTimeRange')
          }
        }
      },
      title: this.$t('TS.singleCallSetUpTime')
    };
  },
  props: [
    'singledata'
  ],
  provide: {
    chart: [ColumnSeries, Legend, DataLabel, Category, Tooltip, Zoom, ScrollBar, Selection]
  },
  methods: {
    buttonClk() {
      this.$refs.setTime.getXasixValue(this.searchConditions.neId);
      this.$refs.setTimePage.show();
    },
    closeTimePage() {
      this.$refs.setTimePage.clear();
      this.$refs.setTimePage.close();
    },
    getData(params) {
      const This = this;
      if (params != null) {
        This.searchConditions = params;
      }
      // 单周期数据获取
      const url = `${This.olapUrl}/lte/ems/olap/voice/getSingleCallSetUpTimeDetail.html?startDate=${This.searchConditions.startdate}&endDate=${This.searchConditions.enddate}&interval=${This.searchConditions.timeInterval}&neId=${This.searchConditions.neId}&xAxisValue=${This.searchConditions.xAxisValue}`;
      This.$axios.get(url).then((response) => {
        if (response && response.status === 200) {
          const resultContent = response.data;
          const dataArr = [];
          let $maximum = 0;
          for (let i = 0; i < resultContent.xAxis.length; i++) {
            const obj = {
              x: resultContent.xAxis[i],
              y: resultContent.yAxis[i]
            };
            dataArr.push(obj);
            const yValue = resultContent.yAxis[i];
            $maximum = ($maximum < yValue) ? yValue : $maximum;
          }
          This.$refs.singleChart.ej2Instances.series[0].dataSource = dataArr;
          This.$refs.singleChart.ej2Instances.primaryYAxis.maximum = ($maximum < 10) ? 10 : null;
          This.$refs.singleChart.ej2Instances.animate();
        }
      });
    },
    saveXAxisTimeFunc() {
      const This = this;
      const submitData = This.$refs.setTime.getSubmitData(This.neId);
      console.log(submitData);
      if(submitData !== '') {
        const url = `${This.olapUrl}/lte/ems/olap/voice/setCallSetUpTimeXaxis.html?neId=${This.searchConditions.neId}&xAxis1=${submitData.xAxis1}&xAxis2=${submitData.xAxis2}&xAxis3=${submitData.xAxis3}&xAxis4=${submitData.xAxis4}&xAxis5=${submitData.xAxis5}&xAxis6=${submitData.xAxis6}&xAxis7=${submitData.xAxis7}&xAxis8=${submitData.xAxis8}&xAxis9=${submitData.xAxis9}`;// todo url
        This.$axios.get(url).then((response) => {
          if (response && response.status === 200) {
            This.closeTimePage();
            This.getData(null);
          }
        });
      }
    }
  }
};

</script>

<style scoped>

</style>
